import {IChangePasswordData} from '../../../api/api.types';

export default class ChangePasswordFormController {
	private changePasswordForm: ng.IFormController;
	private changePasswordData: IChangePasswordData;

	constructor () {

	}
}


/** WEBPACK FOOTER **
 ** ./app/hydromet/userManagement/details/change-password-form.controller.ts
 **/